module.exports = __webpack_public_path__ + "img/zhiyedengji.a6731748.png";